<template>
    <div class="intro-container">
        <Logo />
        <div class="plan-intro">
            <div class="plan-main">
                <div class="plan-video" @click="playVideo">
                    <div class="plan-video-img">
                        <img :src="planVideo.cover_url" >
                    </div>
                    <div class="plan-video-play">
                        <img src="../assets/images/btn_start.png" >
                    </div>
                </div>
                <div class="plan-block">
                    <div class="plan-block-frame thought">
                        <div class="plan-block-title">指导思想</div>
                        <div class="plan-block-text">
                            <img src="../assets/images/png_xiaomalan.png" class="plan-block-img">
                            以习近平新时代中国特色社会主义思想为指导，深入贯彻把稳就业摆在更加突出位置的决策精神，认真落实职业技能提升行动部署要求，扎实推进脱贫攻坚的战略措施，按照政府激励引导、社会广泛参与、劳动者自主选择的原则，面向劳动者开展创业培训，提升劳动者就业创业能力，为加快推动大众创业、万众创新，促进就业倍增效应提供有力支撑。
                        </div>
                    </div>
                </div>
                <div class="plan-block">
                    <div class="plan-block-frame crowd">
                        <div class="plan-block-title">适合人群</div>
                        <div class="plan-block-text">有创业意愿和培训需求的各类城乡劳动者</div>
                    </div>
                </div>
                <div class="plan-block">
                    <div class="plan-block-frame target">
                        <div class="plan-block-title">工作目标</div>
                        <div class="plan-block-text">
                            <p>创业培训机构：突破<span>5000</span>家</p>
                            <p>创业培训师资：年培训不低于<span>8000</span>人</p>
                            <p>创业培训学员：2021年培训不低于<span>200万</span>人次</p>
                        </div>
                    </div>
                </div>
                <div class="plan-title-pic">
                    <img src="../assets/images/png_title_cuoshi.png">
                </div>
                <div class="plan-measures">
                    <div class="measures-title">
                        <em>01</em>
                        <span>明确创业培训内容</span>
                    </div>
                    <div class="against-text">
                        <p>针对处于不同创业阶段的人群</p>
                        <p>有针对性地开展创业培训</p>
                    </div>
                    <div class="measures-list">
                        <div class="measures-item">
                            <div class="item-number">01</div>
                            <div class="item-image ready">
                                <img src="../assets/images/png01.png" >
                            </div>
                            <div class="item-content">
                                <div class="item-title">准备创业和创业初期的人员</div>
                                <div class="item-text">
                                    <div class="item-text-label">课程：</div>
                                    <div class="item-text-desc">创业意识、创办企业、网络创业、创业（模拟）实训等培训课程。</div>
                                </div>
                                <div class="item-text">
                                    <div class="item-text-label">目的：</div>
                                    <div class="item-text-desc">提升项目选择、市场评估、资金预测、创业计划等能力。</div>
                                </div>
                            </div>
                        </div>
                        <div class="measures-item">
                            <div class="item-number">02</div>
                            <div class="item-image orthodox">
                                <img src="../assets/images/png02.png" >
                            </div>
                            <div class="item-content">
                                <div class="item-title">处于创业时期的人员</div>
                                <div class="item-text">
                                    <div class="item-text-label">课程：</div>
                                    <div class="item-text-desc">改善企业和扩大企业等培训课程。</div>
                                </div>
                                <div class="item-text">
                                    <div class="item-text-label">目的：</div>
                                    <div class="item-text-desc">健全管理体系，制定发展战略，抵御外部风险，稳定企业经营，扩大就业岗位。</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>02</em>
                        <span>扩大创业培训群体范围</span>
                    </div>
                    <div class="against-text">
                        <p>有<span>创业意愿</span>和<span>培训需求</span>的城乡各类劳动者</p>
                    </div>
                    <div class="focus-box">
                        <div class="focus-images">
                            <img src="../assets/images/png04.png" >
                        </div>
                        <div class="focus-content">
                            <div class="focus-title"><span>重点人群</span></div>
                            <div class="focus-text">贫困家庭子女、贫困劳动力、城乡未继续升学初高中毕业生、各类职业院校（含技工院校）学生、高校学生、离校2年内未就业高校毕业生、农村转移就业劳动者、返乡入乡创业人员、乡村创业致富带头人、下岗失业人员、转岗职工、小微企业主、个体工商户、就业困难人员（含残疾人）、退役军人、即将刑满释放人员。</div>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>03</em>
                        <span>促进技能与创业创新结合</span>
                    </div>
                    <div class="against-text">
                        <p>以<span>职业院校（含技工院校）、技能大师工作室</span>为载体，促进技能与创业创新结合。</p>
                    </div>
                    <div class="promote-box">
                        <div class="promote-content">
                            <img src="../assets/images/png03.png" class="promote-image">
                            <p class="promote-text">推动职业院校（含技工院校）创业创新培训，将创业创新课程纳入教学计划。</p>
                            <p class="promote-text">依托技能大师工作室等开展多种形式的创业创新活动。</p>
                            <p class="promote-text">将学生在校期间开展的“试创业”实践活动纳入政策支持范围。</p>
                            <p class="promote-text">依托各地创业培训师资培训计划，加速职业院校（含技工院校）创业培训师资培养。</p>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>04</em>
                        <span>完善创业培训资源建设</span>
                    </div>
                    <div class="perfect-box">
                        <div class="perfect-range">
                            <img src="../assets/images/png05.png" class="range-image">
                            <p class="range-title">资源建设依据</p>
                            <p class="range-text">《创业培训标准（试行）》</p>
                            <p class="range-title">资源建设涵盖范围</p>
                            <p class="range-text">不同创业群体、创业活动不同阶段</p>
                        </div>
                        <div class="perfect-action">
                            <img src="../assets/images/png06.png" class="action-image">
                            <p class="action-title">资源建设举措</p>
                            <p class="action-text">构建创业培训课程、教材和案例库</p>
                            <p class="action-text">完善灵活多样的培训模式，如小班互动式教学、创业实训、观摩游学、创业指导等</p>
                            <p class="action-text">探索“互联网+创业培训”，试点翻转课堂等新型培训模式</p>
                            <p class="action-text">加强网络创业培训技术平台建设</p>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>05</em>
                        <span>促进创业培训机构发展</span>
                    </div>
                    <div class="development-box">
                        <div class="development-item strengthen">
                            <div class="development-title">加强创业培训机构规范管理</div>
                            <div class="development-text">指导创业培训机构严格按照《创业培训标准（试行）》开展创业培训和后续服务</div>
                            <!-- <div class="development-image">
                                <img src="../assets/images/png07.png">
                            </div> -->
                        </div>
                        <div class="development-item launch">
                            <div class="development-title">发动优势资源参与创业培训</div>
                            <div class="development-text">支持符合条件的职业培训机构、就业创业培训（实训）中心、各类职业院校（含技工院校）、高校、创业孵化基地、众创空间等实体开展培训</div>
                        </div>
                        <div class="development-item promote">
                            <div class="development-title">提升创业培训机构服务能力</div>
                            <div class="development-text">鼓励培训机构将培训服务“送上门”，为各类机构组织提供培训课程、师资等创业培训优质资源</div>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>06</em>
                        <span>加强创业培训师资队伍建设</span>
                    </div>
                    <div class="build-box">
                        <div class="build-item">
                            <div class="build-content blue">
                                <div class="build-posi">
                                    <div class="build-title">加强师资队伍管理</div>
                                    <div class="build-text">建立创业培训师资库，完善进出、考评和激励机制，实现创业培训师资动态管理</div>
                                    <div class="build-image management">
                                        <img src="../assets/images/png08.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="build-item">
                            <div class="build-content orange">
                                <div class="build-posi">
                                    <div class="build-title">制定师资培养计划</div>
                                    <div class="build-text">定期组织各类创业培训师资培训，并通过提高培训、研讨交流、教学观摩、讲师大赛等活动，提升创业培训师资培训指导能力</div>
                                </div>
                            </div>
                        </div>
                        <div class="build-item">
                            <div class="build-content orange">
                                <div class="build-posi">
                                    <div class="build-title">创新师资培训模式</div>
                                    <div class="build-text">鼓励有条件的地区根据创业培训师资培训需求，创新师资培训市场化模式</div>
                                    <div class="build-image mode">
                                        <img src="../assets/images/png09.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="build-item blue">
                            <div class="build-content blue">
                                <div class="build-posi">
                                    <div class="build-title">组织师资交流大赛</div>
                                    <div class="build-text">持续组织“马兰花全国创业培训讲师大赛”，以赛促培训，以赛促交流，以赛促提高</div>
                                    <div class="build-image contest">
                                        <img src="../assets/images/png10.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>07</em>
                        <span>完善创业培训质量监控体系</span>
                    </div>
                    <div class="system-box">
                        <div class="system-content">
                            <img src="../assets/images/png03.png" class="system-image">
                            <p>加强创业培训日常管理工作，利用<span>大数据、区块链</span>等技术，完善创业培训管理工作。</p>
                            <p>完善质量监控和效果评估体系，加强创业培训信息化平台建设，做好创业培训日常管理、过程监督、培训考核、证书管理、效果评估、资金管理等一体化管理服务，实现<span>培训机构全覆盖、培训人员全实名、培训资金全记录，培训过程可追溯、培训质量可监控。</span></p>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>08</em>
                        <span>强化创业培训后续服务</span>
                    </div>
                    <div class="service-box">
                        <div class="service-item">
                            <div class="service-content blue">
                                <div class="service-title">培训服务<br />有效衔接</div>
                                <div class="service-text">加强创业培训与创业服务的有效衔接和统筹推进</div>
                                <div class="service-image cohesion">
                                    <img src="../assets/images/png12(1).png">
                                </div>
                            </div>
                        </div>
                        <div class="service-item">
                            <div class="service-content orange">
                                <div class="service-title">创业服务<br />多元融合</div>
                                <div class="service-text">依托公共创业服务机构，提供开业指导、担保贷款、创业孵化、创业见习、企业咨询等服务，推动开展线上创业服务</div>
                            </div>
                        </div>
                        <div class="service-item">
                            <div class="service-content blue">
                                <div class="service-title">创业导师<br />广泛吸纳</div>
                                <div class="service-text">吸纳创业培训师资，建立创业导师库，探索支持优秀创业导师成立工作室</div>
                                <div class="service-image absorb">
                                    <img src="../assets/images/png13.png">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>09</em>
                        <span>推动创业培训助力脱贫致富</span>
                    </div>
                    <div class="getrich-box">
                        <div class="getrich-content">
                            <img src="../assets/images/png11.png" class="getrich-image">
                            <div class="getrich-item">
                                <div class="getrich-title">加强创业指导</div>
                                <div class="getrich-text">各地应加强对贫困地区、农村地区、边远地区开展创业培训指导</div>
                            </div>
                            <div class="getrich-item">
                                <div class="getrich-title">开展指导课程</div>
                                <div class="getrich-text">结合乡村创业特点和培训需求，开发创业培训指导课程</div>
                            </div>
                            <div class="getrich-item">
                                <div class="getrich-title">强化队伍建设</div>
                                <div class="getrich-text">加强贫困地区创业培训师资队伍和创业导师队伍建设</div>
                            </div>
                            <div class="getrich-item">
                                <div class="getrich-title">宣传典型事迹</div>
                                <div class="getrich-text">挖掘宣传返乡入乡人员、乡村创业致富带头人和扶贫创业培训师资的典型事迹。</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="plan-title-pic">
                    <img src="../assets/images/png_title_yaoqiu.png">
                </div>
                <div class="plan-measures">
                    <div class="measures-title">
                        <em>01</em>
                        <span>加强实施管理</span>
                    </div>
                    <div class="implement-box">
                        <div class="implement-item">
                            <div class="implement-content">
                                <div class="implement-number">01</div>
                                <div class="implement-text">高度重视<br />专人负责</div>
                            </div>
                        </div>
                        <div class="implement-item">
                            <div class="implement-content">
                                <div class="implement-number">02</div>
                                <div class="implement-text">强化督导<br />落实责任</div>
                            </div>
                        </div>
                        <div class="implement-item">
                            <div class="implement-content">
                                <div class="implement-number">03</div>
                                <div class="implement-text">清单管理<br />及时公布</div>
                            </div>
                        </div>
                        <div class="implement-item">
                            <div class="implement-content">
                                <div class="implement-number">04</div>
                                <div class="implement-text">加强协作<br />解决问题</div>
                            </div>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>02</em>
                        <span>落实资金保障</span>
                    </div>
                    <div class="guarantee-box">
                        <div class="guarantee-image">
                            <img src="../assets/images/png14.png">
                        </div>
                        <div class="guarantee-text">
                            <p>创业培训所需补贴从就业补助资金或职业技能提升行动专账资金中合理统筹安排，职业技能提升行动期间，优先使用职业技能提升行动专账资金。</p>
                            <p>符合条件的人员每人每年参加每个培训课程可享受一次培训补贴。</p>
                            <p>各地可结合实际提高培训补贴标准。</p>
                            <p>有条件的地区可结合本地实际，对教学资源开发、线上创业培训、管理人员培训、管理平台开发等基础工作给予经费支持。</p>
                            <p>各地应健全资金管理制度，明确监管主体，强化使用监管，保障使用安全，提高使用效率。</p>
                        </div>
                    </div>
                    <div class="measures-title">
                        <em>03</em>
                        <span>注重宣传引导</span>
                    </div>
                    <div class="guide-box">
                        <div class="guide-item activity">
                            <div class="guide-title">开展<br>活动</div>
                            <div class="guide-text">结合职业技能提升行动，开展“马兰花计划”主题宣传活动</div>
                        </div>
                        <div class="guide-item strength">
                            <div class="guide-title">加大<br>力度</div>
                            <div class="guide-text">面向城乡各类劳动者加大对创业培训政策宣传力度</div>
                        </div>
                        <div class="guide-item job">
                            <div class="guide-title">推进<br>工作</div>
                            <div class="guide-text">积极运用各种宣传媒介和平台，广泛宣传创业者、创业培训师资、创业培训机构、创业培训管理人员的典型事迹。</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="plan-bottom-image">
                <img src="../assets/images/png_jihua_down.png">
            </div>
        </div>
        <van-overlay :show="isShow">
            <div class="video-close" @click="closeVideo">
                <img src="../assets/images/close.ss.png">
            </div>
            <div class="video-box">
                <video oncontextmenu="return false" width="100%" height="100%" ref="videoPlayer" :src="planVideo.video_url" :poster="planVideo.cover_url" controls controlslist="nodownload" disablePictureInPicture></video>
            </div>
        </van-overlay>
    </div>
</template>


<script>
import { getVideo } from "../api/index"
import Logo from "../components/Logo"

export default {
    name: 'planIntro',
    data() {
        return {
            isShow: false,
            planVideo: {}
        }
    },
    components: {
        Logo
    },
    created() {
        this.getVideo()
    },
    methods: {
        getVideo(){
            getVideo().then(res=>{
                if(res.code == 200){
                    let videoData = res.data.list
                    this.planVideo = videoData.filter(pilot => pilot.type === 2)[0]
                }
            }).catch({})
        },
        playVideo() {
            this.isShow = true
        },
        closeVideo() {
            this.isShow = false
            this.$refs.videoPlayer.pause();
        }
    }
}
</script>
<style lang="scss" scoped>
.plan-intro{
    position: relative;
    background-color: #6A82DD;
    .plan-main{
        padding: 40px 24px 64px;
        .plan-video{
            position: relative;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0px 10px 32px 0px rgba(53,82,194,1);
            .plan-video-img{
                img{
                    display: block;
                    width: 100%;
                    height: 395px;
                }
            }
            .plan-video-play{
                position: absolute;
                width: 122px;
                height: 122px;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                margin: auto;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .plan-block{
            background-color: #fff;
            box-shadow: 0px 4px 16px 0px rgba(53,82,194,0.2);
            border-radius: 8px;
            padding: 48px 24px 24px;
            margin-top: 40px;
            .plan-block-frame{
                position: relative;
                border-width: 1px;
                border-style: dashed;
                .plan-block-title{
                    position: absolute;
                    line-height: 60px;
                    left: 50%;
                    top: -30px;
                    margin: auto;
                    font-size: 40px;
                    font-family: "YouSheBiaoTiHei";
                    color: #FFFFFF;
                    text-align: center;
                    border-radius: 4px;
                    transform: translate(-50%,0);
                    padding: 0 30px;
                }
                &.thought{
                    border-color: #2F54EB;
                    background-color: #F0F7FF;
                    .plan-block-title{
                        background-color: #345CD6;
                    }
                }
                &.crowd{
                    border-color: #78B84B;
                    background-color: #FAFFF6;
                    .plan-block-title{
                        background-color: #78B84B;
                    }
                    .plan-block-text{
                        text-align: center;
                        padding: 56px 0 28px;
                    }
                }
                &.target{
                    border-color: #F4B130;
                    background-color: #FFFEFD;
                    .plan-block-title{
                        background-color: #F4B130;
                    }
                    .plan-block-text{
                        text-align: center;
                        padding: 56px 0 28px;
                        span{
                            font-weight: bold;
                            color: #F4B130;
                            font-size: 32px;
                        }
                    }
                }
                .plan-block-text{
                    font-size: 28px;
                    color: #333333;
                    line-height: 46px;
                    padding: 56px 42px 28px;
                    text-align: justify;
                    .plan-block-img{
                        float: left;
                        width: 121px;
                        margin-right: 24px;
                    }
                }
            }
        }
        .plan-title-pic{
            text-align: center;
            padding: 48px 0 24px;
            img{
                display: inline-block;
                height: 61px;
            }
        }
        .plan-measures{
            background-color: #fff;
            border-radius: 8px;
            padding: 24px 0 40px;
            .measures-title{
                height: 80px;
                line-height: 80px;
                background-image: url(../assets/images/measures_title.png);
                background-size: 100% 100%;
                font-family: "YouSheBiaoTiHei";
                padding: 0 24px;
                display: flex;
                align-items: center;
                em{
                    font-size: 42px;
                    color: #fff;
                    padding-right: 16px;
                    background: linear-gradient(180deg, #FFFFFF 0%, #FFCC54 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                span{
                    font-size: 36px;
                    color: #fff;
                }
            }
            .against-text{
                font-size: 28px;
                color: #333;
                text-align: center;
                line-height: 46px;
                margin-top: 28px;
                padding: 0 24px;
                span{
                    color: #2F54EB;
                    font-size: 32px;
                    padding: 0 8px;
                }
            }
            .measures-list{
                margin-top: 36px;
                margin-bottom: 40px;
                padding: 0 24px;
                .measures-item{
                    position: relative;
                    background-color: #F0F7FF;
                    padding: 0 32px;
                    border-radius: 8px;
                    margin-bottom: 65px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                    .item-number{
                        position: absolute;
                        left: 40px;
                        top: -16px;
                        font-size: 34px;
                        color: #fff;
                        width: 64px;
                        line-height: 64px;
                        background-color: #2F54EB;
                        z-index: 1;
                        text-align: center;
                    }
                    .item-image{
                        position: absolute;
                        &.ready{
                            width: 228px;
                            top: -45px;
                            right: 18px;
                            z-index: 1;
                            img{
                                width: 100%;
                            }
                        }
                        &.orthodox{
                            width: 144px;
                            top: -40px;
                            right: 40px;
                            z-index: 1;
                            img{
                                width: 100%;
                            }
                        }
                    }
                    .item-content{
                        padding-top: 70px;
                        padding-bottom: 20px;
                        .item-title{
                            font-size: 32px;
                            color: #333;
                            margin-bottom: 24px;
                        }
                        .item-text{
                            display: flex;
                            font-size: 28px;
                            color: #393E4D;
                            line-height: 46px;
                            margin-bottom: 10px;
                            .item-text-desc{
                                flex: 1;
                            }
                        }
                    }
                }
            }
            .focus-box{
                margin-top: 24px;
                padding: 0 24px;
                margin-bottom: 40px;
                .focus-images{
                    width: 346px;
                    margin: 0 auto;
                    img{
                        width: 100%;
                    }
                }
                .focus-content{
                    position: relative;
                    background: #F0F7FF;
                    border: 1px dashed #2F54EB;
                    border-radius: 8px;
                    padding: 54px 32px 32px;
                    .focus-title{
                        position: absolute;
                        top: -32px;
                        background-color: #2F54EB;
                        // height: 64px;
                        line-height: 64px;
                        color: #fff;
                        font-size: 32px;
                        text-align: center;
                        padding: 0 48px;
                        left: 50%;
                        transform: translate(-50%, 0);
                        // transform: skewX(-8deg);
                        span{
                            display: block;
                            // transform: skewX(8deg);
                        }
                    }
                    .focus-text{
                        font-size: 28px;
                        color: #393E4D;
                        line-height: 46px;
                    }
                }
            }
            .promote-box{
                margin-top: 32px;
                padding: 0 32px;
                margin-bottom: 36px;
                .promote-content{
                    .promote-image{
                        width: 234px;
                        float: right;
                    }
                    .promote-text{
                        position: relative;
                        font-size: 28px;
                        color: #333;
                        line-height: 46px;
                        padding-left: 22px;
                        margin-bottom: 24px;
                        &::before{
                            content: "";
                            position: absolute;
                            width: 6px;
                            height: 28px;
                            border-radius: 4px;
                            background: linear-gradient(180deg, #5071F8 0%, #2F54EB 100%);
                            left: 0;
                            top: 0;
                            bottom: 0;
                            margin: auto;
                        }
                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                }
            }
            .perfect-box{
                margin-top: 32px;
                padding: 0 24px;
                .perfect-range{
                    background: #F1F6ED;
                    border-radius: 8px;
                    padding: 40px 30px 10px 48px;
                    .range-image{
                        width: 182px;
                        float: right;
                    }
                    .range-title{
                        font-size: 28px;
                        color: #333;
                        margin-bottom: 18px;
                    }
                    .range-text{
                        font-size: 32px;
                        color: #78B84B;
                        font-weight: bold;
                        padding-bottom: 32px;
                    }
                }
                .perfect-action{
                    margin-top: 36px;
                    padding: 0 8px;
                    margin-bottom: 36px;
                    .action-image{
                        width: 151px;
                        float: right;
                    }
                    .action-title{
                        font-size: 32px;
                        color: #2F54EB;
                        margin-bottom: 24px;
                    }
                    .action-text{
                        position: relative;
                        font-size: 28px;
                        color: #333;
                        line-height: 46px;
                        padding-left: 22px;
                        margin-bottom: 24px;
                        &::before{
                            content: "";
                            position: absolute;
                            width: 6px;
                            height: 28px;
                            border-radius: 4px;
                            background: linear-gradient(180deg, #5071F8 0%, #2F54EB 100%);
                            left: 0;
                            top: 0;
                            bottom: 0;
                            margin: auto;
                        }
                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                }
            }
            .development-box{
                padding: 0 24px;
                margin-top: 32px;
                margin-bottom: 40px;
                .development-item{
                    position: relative;
                    margin-bottom: 32px;
                    border-radius: 8px;
                    overflow: hidden;
                    .development-title{
                        position: relative;
                        font-size: 28px;
                        color: #fff;
                        text-align: center;
                        line-height: 64px;
                        background-size: auto 54px;
                        background-position: -12px 10px;
                        background-image: url(../assets/images/png_home_title.png);
                        background-repeat: no-repeat;
                    }
                    .development-text{
                        font-size: 28px;
                        color: #393E4D;
                        line-height: 46px;
                        padding: 24px;
                    }
                    .development-image{
                        position: absolute;
                        width: 120px;
                        bottom: 0;
                        right: 64px;
                        img{
                            display: block;
                            width: 100%;
                        }
                    }
                    &.strengthen{
                        .development-title{
                            background-color: #2F54EB;
                        }
                        .development-text{
                            background-color: #F0F7FF;
                        }
                    }
                    &.launch{
                        .development-title{
                            background-color: #319AFF;
                        }
                        .development-text{
                            background-color: #F1F8FF;
                        }
                    }
                    &.promote{
                        .development-title{
                            background-color: #78B84B;
                        }
                        .development-text{
                            background-color: #F1F6ED;
                        }
                    }
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
            }
            .build-box{
                padding: 0 10px;
                margin-bottom: 40px;
                &::after{
                    content: "";
                    display: block;
                    clear: both;
                }
                .build-item{
                    display: inline-block;
                    vertical-align: top;
                    width: 50%;
                    padding: 0 14px;
                    box-sizing: border-box;
                    overflow: hidden;
                    margin-top: 32px;
                    .build-content{
                        position: relative;
                        .build-posi{
                            position: relative;
                            z-index: 1;
                            border-radius: 12px 72px 12px 12px;
                            padding: 35px 24px 0;
                            min-height: 435px;
                            box-sizing: border-box;
                            padding-bottom: 20px;
                        }
                        &::after{
                            content: "";
                            position: absolute;
                            width: 100%;
                            left: 12px;
                            top: 14px;
                            bottom: 14px;
                            margin: auto;
                            border-radius: 12px 72px 12px 12px;
                            // z-index: -1;
                        }
                        &.blue{
                            .build-posi{
                                background-color: #267CEB;
                            }
                            &::after{
                                content: "";
                                background: #9CC4FB;
                            }

                        }
                        &.orange{
                            .build-posi{
                                background-color: #FA8B43;
                            }
                            &::after{
                                content: "";
                                background: #FFE1B9;
                            }
                        }
                        .build-title{
                            font-size: 32px;
                            color: #fff;
                        }
                        .build-text{
                            font-size: 28px;
                            color: #fff;
                            line-height: 44px;
                            margin-top: 24px;
                        }
                        .build-image{
                            // position: absolute;
                            // bottom: 0;
                            // left: 0;
                            // right: 0;
                            margin: auto;
                            margin-top: 20px;
                            &.management{
                                width: 172px;
                                // bottom: 24px;
                            }
                            &.mode{
                                width: 227px;
                            }
                            &.contest{
                                width: 202px;
                            }
                            img{
                                display: block;
                                width: 100%;
                            }
                        }
                    }
                }
            }
            .system-box{
                margin: 32px 0;
                padding: 0 24px;
                .system-content{
                    font-size: 28px;
                    color: #333;
                    line-height: 46px;
                    p{
                        margin-bottom: 32px;
                        &:last-child{
                            margin-bottom: 0;
                        }
                        span{
                            font-size: 32px;
                            color: #2F54EB;
                        }
                    }
                    .system-image{
                        float: right;
                        width: 178px;
                    }
                }
            }
            .service-box{
                margin: 32px 0 40px;
                padding: 0 16px;
                overflow: hidden;
                .service-item{
                    float: left;
                    width: 33.33333%;
                    padding: 0 8px;
                    box-sizing: border-box;
                    .service-content{
                        position: relative;
                        width: 100%;
                        min-height: 535px;
                        box-sizing: border-box;
                        border-radius: 8px 8px 106px 106px;
                        overflow: hidden;
                        padding-bottom: 50px;
                        &.blue{
                            border: 1px solid #2F54EB;
                            .service-title{
                                background-color: #2F54EB;
                            }
                        }
                        &.orange{
                            border: 1px solid #FA8B43;
                            .service-title{
                                background-color: #FA8B43;
                            }
                        }
                        .service-title{
                            font-size: 28px;
                            color: #fff;
                            line-height: 36px;
                            padding: 15px 0;
                            background-size: auto 54px;
                            background-position: -12px 52px;
                            background-image: url(../assets/images/png_home_title.png);
                            background-repeat: no-repeat;
                            text-align: center;
                        }
                        .service-text{
                            font-size: 26px;
                            color: #393E4D;
                            line-height: 40px;
                            padding: 16px;
                        }
                        .service-image{
                            margin: 0 auto;
                            &.cohesion{
                                width: 143px;
                                margin-top: 100px;
                                img{
                                    display: block;
                                    width: 100%;
                                }
                            }
                            &.absorb{
                                width: 144px;
                                margin-top: 30px;
                                img{
                                    display: block;
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }
            .getrich-box{
                margin: 40px 0 0;
                padding: 0 24px;
                .getrich-content{
                    .getrich-image{
                        float: right;
                        width: 180px;
                    }
                    .getrich-item{
                        margin-bottom: 32px;
                        padding-left: 20px;
                        .getrich-title{
                            position: relative;
                            font-size: 32px;
                            color: #2F54EB;
                            line-height: 42px;
                            &::before{
                                content: "";
                                position: absolute;
                                left: -20px;
                                top: 0;
                                bottom: 0;
                                margin: auto;
                                width: 6px;
                                height: 32px;
                                background: linear-gradient(180deg, #5071F8 0%, #2F54EB 100%);
                                border-radius: 4px;
                            }
                        }
                        .getrich-text{
                            font-size: 28px;
                            color: #333;
                            line-height: 46px;
                            margin-top: 16px;
                        }
                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                }
            }
            .implement-box{
                padding: 0 65px;
                overflow: hidden;
                margin: 0 -18px;
                margin-bottom: 40px;
                .implement-item{
                    float: left;
                    width: 50%;
                    padding: 0 18px;
                    box-sizing: border-box;
                    margin-top: 36px;
                    .implement-content{
                        padding: 20px 0;
                        position: relative;
                        background-image: url(../assets/images/png18.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        .implement-number{
                            position: absolute;
                            right: -20px;
                            top: -12px;
                            // width: 48px;
                            // height: 48px;
                            padding: 0 9px;
                            line-height: 48px;
                            background-color: #F0AB25;
                            border-radius: 50%;
                            font-size: 28px;
                            color: #fff;
                            text-align: center;
                        }
                        .implement-text{
                            font-size: 28px;
                            color: #fff;
                            text-align: center;
                            line-height: 40px;
                        }
                    }
                }
            }
            .guarantee-box{
                padding: 0 32px;
                margin: 25px 0 40px;
                .guarantee-image{
                    text-align: center;
                    margin-bottom: 18px;
                    img{
                        display: inline-block;
                        width: 410px;
                    }
                }
                .guarantee-text{
                    font-size: 28px;
                    color: #333;
                    line-height: 46px;
                    p{
                        position: relative;
                        padding-left: 22px;
                        margin-bottom: 24px;
                        &:last-child{
                            margin-bottom: 0;
                        }
                        &::after{
                            content: "";
                            position: absolute;
                            left: 0;
                            top: 0;
                            bottom: 0;
                            margin: auto;
                            width: 6px;
                            height: 32px;
                            background: linear-gradient(180deg, #5071F8 0%, #2F54EB 100%);
                            border-radius: 4px;
                        }
                    }
                }
            }
            .guide-box{
                padding: 32px 24px 0;
                .guide-item{
                    margin-bottom: 32px;
                    display: flex;
                    height: 190px;
                    border-radius: 8px;
                    overflow: hidden;
                    align-items: center;
                    &.activity{
                        border: 1px solid #2F54EB;
                        .guide-title{
                            background-color: #2F54EB;
                        }
                        .guide-text{
                            background-color: #F0F7FF;
                            background-image: url(../assets/images/png15.png);
                            background-size: 185px;
                        }
                    }
                    &.strength{
                        border: 1px solid #FA8B43;
                        .guide-title{
                            background-color: #FA8B43;
                        }
                        .guide-text{
                            background-color: #FFFBF9;
                            background-image: url(../assets/images/png16.png);
                            background-size: 186px;
                        }
                    }
                    &.job{
                        border: 1px solid #78B84B;
                        .guide-title{
                            background-color: #78B84B;
                        }
                        .guide-text{
                            background-color: #F1F6ED;
                            background-image: url(../assets/images/png17.png);
                            background-size: 181px;
                        }
                    }
                    .guide-title{
                        font-size: 32px;
                        color: #fff;
                        height: 100%;
                        line-height: 40px;
                        padding: 0 20px;
                        border-radius: 8px;
                        overflow: hidden;
                        background-size: auto 68px;
                        background-position: -12px 125px;
                        background-image: url(../assets/images/png_home_title.png);
                        background-repeat: no-repeat;
                        text-align: center;
                        display: flex;
                        align-items: center;
                    }
                    .guide-text{
                        display: flex;
                        flex: 1;
                        align-items: center;
                        font-size: 28px;
                        color: #5A6074;
                        padding: 0 24px;
                        height: 100%;
                        line-height: 46px;
                        background-repeat: no-repeat;
                        background-position: right bottom;
                    }
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
    .plan-bottom-image{
        width: 100%;
        img{
            display: block;
            width: 100%;
        }
    }
}
.video-close{
    position: absolute;
    width: 84px;
    height: 84px;
    right: 0;
    top: 0;
    margin: auto;
    img{
        display: block;
        width: 48px;
        height: 48px;
        margin-top: 18px;
        margin-left: 18px;
    }
}
.video-box{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 84px;
    margin: auto;
}
</style>
